<lp-inventory [items]="items()" style="display: block; width: max-content" />
